import { render } from "./OperationProcessHeaderCard2.vue?vue&type=template&id=01de67fb&scoped=true"
import script from "./OperationProcessHeaderCard2.vue?vue&type=script&lang=js"
export * from "./OperationProcessHeaderCard2.vue?vue&type=script&lang=js"

import "./OperationProcessHeaderCard2.vue?vue&type=style&index=0&id=01de67fb&lang=scss&scoped=true"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01de67fb"]])

export default __exports__